import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllBlogs.css";
import healthyLawn from '../../../assets/img/lawn-health.jpg'
import pelletizedCompost from "../../../assets/img/pelletized-compost.jpg";

export default function LawnIsAliveBlog() {
  const location = useLocation();

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "Compost vs. Topsoil: Lawn Health in Vancouver | BUR-HAN Garden & Lawn Care";
    document.title = newTitle;

    const newDescription = "Discover why compost—not topsoil—is the secret to a lush lawn in Vancouver's sandy soils. Learn how BUR-HAN's pelletized compost service transforms lawns across the Lower Mainland.";

    const descriptionMetaTag = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
      "lawn compost service Vancouver",
      "Vancouver lawn care",
      "sandy soil fix",
      "organic compost for sandy soil Vancouver",
      "pelletized compost application North Vancouver",
      "lawn soil health Lower Mainland",
      "lawn care service Vancouver",
      "compost topdressing North Vancouver",
      "lawn health service Burnaby",
      "sandy soil repair Richmond",
      "organic lawn care Surrey"
    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="beforeSection"></div>
      <div className="sectionBlogpost compostTopsoil">
        <a href="/blog" className="backPosts">
          <i className="bi bi-arrow-left"></i>
          Back
        </a>
        <article>
          <header>
            <h1>
              <div className="nth-line-1" data-aos="fade-up">
                Boost Your Lawn's Health:
              </div>
              <div className="nth-line-2" data-aos="fade-up">
                Why Compost Beats Topsoil in Sandy Soils
              </div>
            </h1>
          </header>
          <hr />
          <section data-aos="fade-right">
            <p>
              A thriving lawn starts with healthy soil. For homeowners in Vancouver's Lower Mainland, sandy soils pose a unique challenge: they drain too fast and lack nutrients. While many reach for topsoil to "fix" their lawn, science shows compost is the true game-changer—especially when applied as a professional service.
              <br />
             
            </p>

            <p>
              <span>The Power of Organic Matter</span>
              <br />
              <strong>- Water Retention: </strong>

              Organic matter acts like a sponge, helping sandy soils hold onto water and making it available to grass roots.
              <br />
              <strong>- Nutrient Supply: </strong>
            
              Compost provides a slow, steady release of nutrients as it breaks down, supporting healthier and more resilient grass.
              <br />
              <strong>- Soil Structure: </strong>
            
              Organic matter binds soil particles, improves aeration, and helps prevent compaction and surface crusting.
            </p>

            <p>
              <strong>- Microbial Activity — The Heart of Soil Health: </strong>
           
              One of the most important, yet often overlooked, benefits of adding organic matter is how it fuels beneficial soil microbes. These tiny organisms—bacteria, fungi, and others—are the engine that drives nutrient cycling in your lawn. As microbes break down organic matter, they transform nutrients like nitrogen, phosphorus, and sulfur from forms that grass roots cannot use into forms that are readily absorbed.
              <br/>
            - The relationship between plants and soil microbes is a dynamic partnership. Grass roots release carbon-rich compounds into the soil, which serve as food for microbes. In return, microbes make essential nutrients available to the plants, often making the difference between a lush, healthy lawn and one that struggles to thrive. Mycorrhizal fungi, for example, form symbiotic relationships with grass roots, extending their reach and efficiency in absorbing water and nutrients—especially phosphorus. Nitrogen-fixing bacteria convert atmospheric nitrogen into forms that grass can use, further boosting soil fertility.
              <br/>
             - Healthy microbial populations also help suppress soil-borne diseases and produce plant hormones that support root growth and stress resilience. In short, robust microbial activity ensures a continuous, natural supply of nutrients, reduces the need for synthetic fertilizers, and creates an environment where your lawn can access everything it needs for vigorous, sustainable growth.
              <br />
             
            </p>

            <p>
              <span>Why Compost Outperforms Topsoil on Sandy Lawns</span>
              <br />
              <strong>- Topsoil is Variable: </strong>
            
              Topsoil quality varies widely and often lacks the organic richness needed for lasting improvement, especially in sandy soils.
              <br />
              <strong> - Sand's Limitations: </strong>
             
              Sandy soils don't hold water or nutrients well. Adding more topsoil—especially if it's also sandy—does little to address these fundamental issues.
              <br />
              <strong>- Compost Directly Addresses Deficiencies: </strong>
            
              Compost is rich in organic matter and beneficial microbes. When applied to sandy lawns, it improves water retention, nutrient availability, and soil structure, resulting in thicker, greener grass.
              <br />
              <strong>- Research-Backed Results: </strong>
       
              Lawns treated with compost have greater turf cover, increased soil water retention, and decreased surface hardness compared to those managed with only topsoil or fertilizers.
            </p>

            <p>
              <img loading="lazy"
                src={pelletizedCompost}
                alt="Pelletized compost product for easy application"
                title="Weed-Free Pelletized Compost for Lawns"
                className="img-responsive"
              />
              <span>BUR-HAN Pelletized Compost Application Service</span>
              <br />
              BUR-HAN offers a professional pelletized compost application service designed to maximize these benefits for your lawn. Our pelletized compost is guaranteed weed-free, ensuring you enrich your lawn without introducing unwanted plants. The pellet form allows for precise, uniform application, so every part of your lawn receives the same nutrient boost, leading to more consistent grass growth and soil improvement. Pelletized compost is also cost-effective, easy to handle, and provides long-lasting results.
              <br />
              With our service, you can enjoy the full advantages of compost topdressing—improved soil health, better water retention, increased microbial activity, and enhanced resilience—without the hassle of handling materials or equipment yourself.
            </p>

            <p>
              <span>Service Areas: Where We Transform Lawns</span>
              <br />
              BUR-HAN proudly serves residential and commercial properties across:
              <br />
              - Vancouver (Kitsilano, West End, Mount Pleasant, and more)
              <br />
              - North Vancouver (Lynn Valley, Edgemont, Deep Cove)
              <br />
              - Burnaby
              <br />
              - Richmond
              <br />
              - Surrey
              <br />
              - The entire Lower Mainland
              <br />
              <img loading="lazy"
                src={healthyLawn}
                alt="Healthy green lawn after compost treatment"
                title="Lawn Transformation with Compost"
                className="img-responsive"
              />
            </p>

            <p>
              If you're ready to see your lawn thrive, contact <strong style={{ color: "var(--yellow-color)" }}>BUR-HAN Garden & Lawn Care</strong> today for a quote on our pelletized compost application service!
            </p>
          </section>
        </article>
        <div className="relatedArticles">
          <h3>Related Articles</h3>
          <ul>
            <li><a href="/blog/organic-vs-synthetic-fertilizer-vancouver">Organic vs Synthetic Fertilizer: What's Best for Vancouver Lawns?</a></li>
            <li><a href="/blog/when-to-fertilize-lawn-vancouver">When to Fertilize Your Lawn in Vancouver</a></li>
            <li><a href="/blog/spring-lawn-care-checklist-vancouver">Spring Lawn Care Checklist for Greater Vancouver Homeowners</a></li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
}